import React from "react";
import styled from "styled-components";

import MdTabs from "@material-ui/core/Tabs";
import MdTab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import MdBox from "@material-ui/core/Box";
import MdInput from "@material-ui/core/Input";

export const Tabs = styled(MdTabs)``;

export const Tab = styled(MdTab)``;

export const Box = styled(MdBox)``;

export const Text = styled(Typography)``;

export const PrimaryBtn = styled.button`
  background: var(--primary-color);
  color: white;
  padding: 0px 12px;
  line-height: 20px;
  min-height: 40px;
  & * {
    color: white;
    line-height: 40px;
  }
  @media (min-width: 426px) {
    line-height: 40px;
  }
`;

export const FlatBtn = styled.button`
  color: var(--primary-color);
  background: none;
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Panel = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 20px;
  padding-bottom: 20px;
`;

export const Input = styled(MdInput)`
  width: ${(props) => props.width};
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  padding: 10px 20px;
  width: 100%;
  &:focus,
  :hover {
    border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
  }
  &::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: rgba(0, 0, 0, 0.7);
  }
`;

export const TextArea = styled.textarea`
  width: ${(props) => props.width};
  border: 1px solid #c4c4c4;

  & :focus,
  :hover {
    border: 1px solid #373737;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > label {
    margin: 0;
  }
  & > input {
    font-size: 14px;
    width: ${(props) => props.width || "100%"};

    border: 1px solid #c4c4c4;

    & :focus,
    :hover {
      border: 1px solid #373737;
    }
  }
  & textarea {
    font-size: 14px;
    width: ${(props) => props.width};
    border: 1px solid #c4c4c4;

    & :focus,
    :hover {
      border: 1px solid #373737;
    }
  }
`;

export const MobileHidden = styled.div`
  display: none;
  @media (min-width: 426px) {
    display: block;
  }
`;

export const PanelSection = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 10px;
  padding: 10px;
  margin: 0 auto;
  margin-top: 10px;
  width: 100%;
  @media (min-width: 426px) {
    margin-top: 0;
    padding: 20px 10px;
    flex-direction: row;
    & > div:first-child {
      width: 40%;
    }
    & > div:last-child {
      width: 60%;
    }
  }
`;

export const PanelDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  padding-right: 10px;
  position: relative;

  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
  @media (min-width: 426px) {
    border-bottom: none;
    margin-bottom: inherit;
    padding-bottom: inherit;
  }
`;

export const PanelContent = styled.div`
  padding-left: 10px;
`;

export const ContainerButtonSubmit = styled.div`
  display: flex;
  align-items: center;
  & > *:first-child {
    margin-right: 10px;
  }
`;

export const SignInError = styled.span`
  color: red;
  font-size: 12px;
  line-height: 1;
  text-align: center;
`;

export const Suggestion = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 10px;
  margin-left: 10px;
`;

export const Beta = styled.span`
  & > span {
    font-size: 10px;
    padding: 5px;
    background: white;
    color: orange;
    border-radius: 10px;
    border: 1px solid orange;
    font-weight: bold;
  }
`;

export const Row = styled.div`
  width: 100%;
  position: relative;
  padding-top: 50px;
  padding-bottom: 5px;
  text-align: left;
  ${({ horizontalCenter }) =>
    horizontalCenter &&
    `
  display:flex; 
  justify-content:center;
`}
`;
